//import React, { Suspense } from "react"; // Import Suspense
//import ReactDOM from "react-dom";
//import "./i18n"; // Ensure i18n is imported
//import { Provider } from "react-redux";
//import { ConnectedRouter } from "react-router-redux";
//import { createBrowserHistory } from "history";
//import configureStore from "./store/configureStore";
//import App from "./App";
//import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
//import CssBaseline from "@material-ui/core/CssBaseline";
//import { SnackbarProvider } from "notistack";
//import Cookies from "js-cookie";
//import { config } from "./helpers/config";
//import { getLoggedUser, handleResponse, handleError } from "./helpers";
//import { unregister } from "./registerServiceWorker"; // Import unregister

//// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
//const history = createBrowserHistory({ basename: baseUrl });

//// Get the application-wide store instance, prepopulating with state from the server where available.
//const initialState = window.initialReduxState;
//const store = configureStore(history, initialState);

//const rootElement = document.getElementById("root");
//const themee = createMuiTheme({
//    palette: {
//        primary: {
//            main: "#760e26",
//            light: "#bbbbbb",
//        },
//        secondary: {
//            main: "#cccccc",
//        },
//    },
//    typography: {
//        fontFamily: ["Open Sans", "sans-serif"].join(","),
//    },
//});

//const render = function () {
//    return ReactDOM.render(
//        <Provider store={store}>
//            <ConnectedRouter history={history}>
//                <MuiThemeProvider theme={themee}>
//                    <CssBaseline />
//                    <SnackbarProvider
//                        anchorOrigin={{
//                            vertical: "top",
//                            horizontal: "right",
//                        }}
//                    >
//                        <LanguageSwitcher /> {/* Add LanguageSwitcher here */}
//                        <Suspense fallback={<div>Loading...</div>}> {/* Add Suspense here */}
//                            <App />
//                        </Suspense>
//                    </SnackbarProvider>
//                </MuiThemeProvider>
//            </ConnectedRouter>
//        </Provider>,
//        rootElement
//    );
//};

//// Check for student remote credentials:
//const loggedUser = getLoggedUser();

//if (!loggedUser) {
//    var unwesauth = Cookies.get("unwesauth");
//    if (unwesauth !== undefined) {
//        fetch(`/api/authentication/remote`, {
//            method: "POST",
//        })
//            .then(handleResponse)
//            .then(
//                (loggedUser) => {
//                    if (loggedUser && loggedUser.id) {
//                        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
//                        return loggedUser;
//                    }
//                },
//                (error) => {
//                    render();
//                }
//            )
//            .then(() => render());
//    } else render();
//} else render();

//unregister(); // Call unregister (if needed)

import React, { Suspense } from "react"; // Import Suspense
import "./index.css";
import "./components/NavBar.css";
//import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import App from "./App";
import LanguageSwitcher from "./components/LanguageSwitcher"; // Import LanguageSwitcher
import registerServiceWorker, { unregister } from "./registerServiceWorker";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { SnackbarProvider } from "notistack";
import Cookies from "js-cookie";
import { config } from "./helpers/config";
import { getLoggedUser, handleResponse, handleError } from "./helpers";
//import { unregister } from "./registerServiceWorker"; // Import unregister
import "./i18n"; // Import i18n configuration

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById("root");
const themee = createMuiTheme({
    palette: {
        primary: {
            main: "#760e26",
            light: "#bbbbbb",
        },
        secondary: {
            main: "#cccccc",
        },
    },
    typography: {
        fontFamily: ["Open Sans", "sans-serif"].join(","),
    },
});

const render = function () {
    return ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <MuiThemeProvider theme={themee}>
                    <CssBaseline />
                    <SnackbarProvider
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        
                        <Suspense fallback={<div>Loading...</div>}> {/* Add Suspense here */}
                            {/*<LanguageSwitcher /> */}{/* Add LanguageSwitcher here */}
                            <App />
                        </Suspense>
                    </SnackbarProvider>
                </MuiThemeProvider>
            </ConnectedRouter>
        </Provider>,
        rootElement
    );
};

// Check for student remote credentials:
const loggedUser = getLoggedUser();

if (!loggedUser) {
    var unwesauth = Cookies.get("unwesauth");
    if (unwesauth !== undefined) {
        fetch(`/api/authentication/remote`, {
            method: "POST",
        })
            .then(handleResponse)
            .then(
                (loggedUser) => {
                    if (loggedUser && loggedUser.id) {
                        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
                        return loggedUser;
                    }
                },
                (error) => {
                    render();
                }
            )
            .then(() => render());
    } else render();
} else render();

unregister();


//-------�����------//
//import "./index.css";
//import "./components/NavBar.css";
//import React from "react";
//import ReactDOM from "react-dom";
//import { Provider } from "react-redux";
//import { ConnectedRouter } from "react-router-redux";
//import { createBrowserHistory } from "history";
//import configureStore from "./store/configureStore";
//import App from "./App";
//import LanguageSwitcher from "./components/LanguageSwitcher"; // Import LanguageSwitcher
//import registerServiceWorker, { unregister } from "./registerServiceWorker";
//import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
//import CssBaseline from "@material-ui/core/CssBaseline";
//import { SnackbarProvider } from "notistack";
//import Cookies from "js-cookie";
//import { config } from "./helpers/config";
//import { getLoggedUser, handleResponse, handleError } from "./helpers";

//// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
//const history = createBrowserHistory({ basename: baseUrl });

//// Get the application-wide store instance, prepopulating with state from the server where available.
//const initialState = window.initialReduxState;
//const store = configureStore(history, initialState);

//const rootElement = document.getElementById("root");
//const themee = createMuiTheme({
//  palette: {
//    primary: {
//      main: "#760e26",
//      light: "#bbbbbb",
//    },
//    secondary: {
//      main: "#cccccc",
//    },
//  },
//  typography: {
//    fontFamily: ["Open Sans", "sans-serif"].join(","),
//  },
//});

//const render = function () {
//  return ReactDOM.render(
//    <Provider store={store}>
//      <ConnectedRouter history={history}>
//        <MuiThemeProvider theme={themee}>
//          <CssBaseline />
//          <SnackbarProvider
//            anchorOrigin={{
//              vertical: "top",
//              horizontal: "right",
//            }}
//          >
//            <LanguageSwitcher /> {/* Add LanguageSwitcher here */}
//            <App />
//          </SnackbarProvider>
//        </MuiThemeProvider>
//      </ConnectedRouter>
//    </Provider>,
//    rootElement
//  );
//};

//// Check for student remote credentials:
//const loggedUser = getLoggedUser();

//if (!loggedUser) {
//  var unwesauth = Cookies.get("unwesauth");
//  if (unwesauth !== undefined) {
//    fetch(`/api/authentication/remote`, {
//      method: "POST",
//    })
//      .then(handleResponse)
//      .then(
//        (loggedUser) => {
//          if (loggedUser && loggedUser.id) {
//            localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
//            return loggedUser;
//          }
//        },
//        (error) => {
//          render();
//        }
//      )
//      .then(() => render());
//  } else render();
//} else render();

//unregister();